import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      light: "#b2c399",
      main: "#3f6800",
    },
    gray: {
      main: "#f5f5f5",
    },
    disabled: "#cccccc",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: "var(--primary-color)",
          color: "white",
          borderRadius: "12px",
          width: "100%",
          fontWeight: "700",
          textTransform: "none",
        },
      },
    },
  },
});

export default theme;
